module.exports = __webpack_public_path__ + "static/media/814PVmS7JyL._SL1500_.152f7e7d.jpg";